import { FormikContextType } from 'formik';

import { FormFieldsUnion } from '../../../utils/hooks/useFormFieldsByCategory';
import GenericDropdown, { IGenericDropdownProps } from '../../formInputs/GenericDropdown';
import GenericInput, { IGenericInputProps } from '../../formInputs/GenericInput';
import GenericInputArea, { IGenericInputAreaProps } from '../../formInputs/GenericInputArea';
import GenericPillsDropdown, {
  IGenericPillsDropdownProps,
} from '../../formInputs/GenericPillsDropdown';
import GenericCheckbox, { GenericCheckboxProps } from '../../formInputs/GenericCheckbox';
import TranslatorDropdown, { TranslatorDropdownProps } from '../../formInputs/TranslatorDropdown';
import { IValues } from '../../../utils/common/types';
import GenericChips, { IGenericChipsProps } from '../../formInputs/GenericChips';

interface IRenderFormField {
  field: FormFieldsUnion;
  props: FormikContextType<IValues>;
}

function RenderFormField({ field, props }: IRenderFormField) {
  const newProps = { ...field.properties, formProps: props };

  switch (field.type) {
    case 'translatorDropdown': {
      return <TranslatorDropdown {...(newProps as TranslatorDropdownProps)} />;
    }
    case 'textarea':
      return <GenericInputArea {...(newProps as IGenericInputAreaProps)} />;
    case 'input':
      return <GenericInput {...(newProps as IGenericInputProps)} />;
    case 'dropdown':
      return <GenericDropdown {...(newProps as IGenericDropdownProps)} />;
    case 'pillsDropdown': {
      return <GenericPillsDropdown {...(newProps as IGenericPillsDropdownProps)} />;
    }
    case 'checkbox': {
      return <GenericCheckbox {...(newProps as GenericCheckboxProps)} />;
    }
    case 'chips': {
      return <GenericChips {...(newProps as IGenericChipsProps)} />;
    }
  }
}

export default RenderFormField;
